var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ConfirmationModal",
    {
      key: _vm.componentKey,
      attrs: {
        title: _vm.$t("AUTH_MODAL_TITLE"),
        "confirm-action-text": _vm.$t("CONFIRM_BUTTON"),
        "confirm-button-loading": _vm.isLoading
      },
      on: {
        confirm: function($event) {
          return _vm.onConfirm()
        },
        close: function($event) {
          return _vm.onCloseModal()
        },
        dismiss: function($event) {
          return _vm.onDismissModal()
        }
      }
    },
    [
      _c("ValidationObserver", { ref: "formValidation", attrs: { slim: "" } }, [
        _c("form", { attrs: { role: "form" } }, [
          _vm.authType == "password"
            ? _c(
                "fieldset",
                [
                  _c("Field", {
                    attrs: { label: _vm.$t("INPUT_EMAIL") },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "element",
                          fn: function() {
                            return [
                              _c("ValidationProvider", {
                                attrs: { slim: "", rules: "required|email" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ errors }) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "row",
                                              class: {
                                                "ng-invalid ng-submitted":
                                                  errors.length > 0
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-sm-6 col-md-6 col-xs-10"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.email,
                                                        expression: "email"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "ng-invalid ng-touched":
                                                        errors.length > 0
                                                    },
                                                    attrs: {
                                                      id: "emailInput",
                                                      type: "email",
                                                      autocomplete: "off",
                                                      required: "true"
                                                    },
                                                    domProps: {
                                                      value: _vm.email
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.email =
                                                          $event.target.value
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  errors.length > 0
                                                    ? _c("span", {
                                                        directives: [
                                                          {
                                                            name: "t",
                                                            rawName: "v-t",
                                                            value:
                                                              "INPUT_EMAIL_ERROR_DESCRIPTION",
                                                            expression:
                                                              "'INPUT_EMAIL_ERROR_DESCRIPTION'"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "text-danger"
                                                      })
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("label", {
                                                directives: [
                                                  {
                                                    name: "t",
                                                    rawName: "v-t",
                                                    value: "REQUIRED_LABEL",
                                                    expression:
                                                      "'REQUIRED_LABEL'"
                                                  }
                                                ],
                                                staticClass:
                                                  "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                              })
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  3954610897
                                )
                              })
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      1649872527
                    )
                  }),
                  _vm._v(" "),
                  _c("Field", {
                    attrs: { label: _vm.$t("INPUT_PASSWORD") },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "element",
                          fn: function() {
                            return [
                              _c("ValidationProvider", {
                                attrs: { slim: "", rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ errors }) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "row",
                                              class: {
                                                "ng-invalid ng-submitted":
                                                  errors.length > 0
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-sm-6 col-md-6 col-xs-10"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: _vm.password,
                                                        expression: "password"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "ng-invalid ng-touched":
                                                        errors.length > 0
                                                    },
                                                    attrs: {
                                                      id: "passwordInput",
                                                      type: "password",
                                                      autocomplete: "off",
                                                      required: "true"
                                                    },
                                                    domProps: {
                                                      value: _vm.password
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.password =
                                                          $event.target.value
                                                      }
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("label", {
                                                directives: [
                                                  {
                                                    name: "t",
                                                    rawName: "v-t",
                                                    value: "REQUIRED_LABEL",
                                                    expression:
                                                      "'REQUIRED_LABEL'"
                                                  }
                                                ],
                                                staticClass:
                                                  "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                              })
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  675802324
                                )
                              })
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      2166124619
                    )
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.authType == "mfa"
            ? _c(
                "fieldset",
                [
                  _c("Field", {
                    attrs: {
                      label: _vm.$t("INPUT_MULTI_FACTOR_CODE"),
                      "has-tooltip": true,
                      "tooltip-text": _vm.$t("MULTI_FACTOR_AUTH_TT")
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "element",
                          fn: function() {
                            return [
                              _c("ValidationProvider", {
                                attrs: { slim: "", rules: "required" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ errors }) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "row",
                                              class: {
                                                "ng-invalid ng-submitted":
                                                  errors.length > 0
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-sm-6 col-md-6 col-xs-10"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.multiFactorAuthCode,
                                                        expression:
                                                          "multiFactorAuthCode"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: {
                                                      "ng-invalid ng-touched":
                                                        errors.length > 0
                                                    },
                                                    attrs: {
                                                      id:
                                                        "multiFactorAuthCodeInput",
                                                      type: "text",
                                                      autocomplete: "off",
                                                      required: "true"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.multiFactorAuthCode
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.multiFactorAuthCode =
                                                          $event.target.value
                                                      }
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("label", {
                                                directives: [
                                                  {
                                                    name: "t",
                                                    rawName: "v-t",
                                                    value: "REQUIRED_LABEL",
                                                    expression:
                                                      "'REQUIRED_LABEL'"
                                                  }
                                                ],
                                                staticClass:
                                                  "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                              })
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  2919930248
                                )
                              })
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      30816523
                    )
                  })
                ],
                1
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }